import React from 'react';
import SchemaForm from './schema_form';
import styles from '../../app.module.css';

const SchemaList = ({
    schemas,
    editingSchemaName,
    editingSchemaData,
    onEdit,
    onDelete,
    onSave,
    onCancel,
}) => {
    const schemaKeys = Object.keys(schemas);
    return (
        <div>
            {schemaKeys.length === 0 && (
                <p>No existing schemas to display.</p>
            )}

            {schemaKeys.map((name) => {
                const isEditing = editingSchemaName === name;
                if (isEditing) {
                    return (
                        <div key={name}>
                            <SchemaForm
                                initialData={editingSchemaData}
                                onSave={onSave}
                                onCancel={onCancel}
                                existingSchemas={schemaKeys}
                            />
                        </div>
                    );
                }

                const { type, description, properties, required, items } = schemas[name];
                return (
                    <div
                        key={name}
                        className={styles.mainContainer}
                    >
                        <p>
                            <strong>Name:</strong> {name}
                        </p>
                        <p>
                            <strong>Type:</strong> {type}
                        </p>
                        <p>
                            <strong>Description:</strong> {description || 'No description'}
                        </p>

                        {type === 'array' && items && (
                            <p>
                                <strong>Items:</strong>{' '}
                                {items.$ref
                                    ? items.$ref.replace('#/components/schemas/', '')
                                    : items.type || 'N/A'}
                                {items.format && ` (format: ${items.format})`}
                            </p>
                        )}

                        {properties && Object.keys(properties).length > 0 && (
                            <div>
                                <strong>Properties:</strong>
                                <table className={styles.schemaProperties}>
                                    <thead>
                                        <tr>
                                            <th className={styles.tableHeading}>
                                                Name
                                            </th>
                                            <th className={styles.tableHeading}>
                                                Type
                                            </th>
                                            <th className={styles.tableHeading}>
                                                Format
                                            </th>
                                            <th className={styles.tableHeading}>
                                                Description
                                            </th>
                                            <th className={styles.tableHeading}>
                                                Required
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.entries(properties).map(([propName, details]) => (
                                            <tr key={propName}>
                                                <td
                                                    className={styles.tableContents}
                                                >
                                                    {propName}
                                                </td>
                                                <td
                                                    className={styles.tableContents}
                                                >
                                                    {details.$ref
                                                        ? details.$ref.replace('#/components/schemas/', '')
                                                        : details.type || 'N/A'}
                                                </td>
                                                <td
                                                    className={styles.tableContents}
                                                >
                                                    {details.format || 'N/A'}
                                                </td>
                                                <td
                                                    className={styles.tableContents}
                                                >
                                                    {details.description || 'No description'}
                                                </td>
                                                <td
                                                    className={styles.tableContents}
                                                >
                                                    {required?.includes(propName) ? 'Yes' : 'No'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className={styles.actionButtonsContainer} >
                            <button className={styles.editButton} onClick={() => onEdit(name)}> Edit </button>
                            <button className={styles.deleteButton} onClick={() => onDelete(name)}> Delete </button>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default SchemaList;
